(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-your-stage"] && !Shopify.designMode) return;
  try {
    
 (function(){
  function stageKey(value){
    var key=String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
    if(key==='premenstrual'||key==='cyclingyears')return 'premenstrual';
    if(key==='perim'||key==='perimenopause')return 'peri-m';
    if(key==='postm'||key==='postmenopause'||key==='postmenopausal')return 'post-m';
    return key;
  }
  function tabFor(target,key){
    return Array.from(target.querySelectorAll('[data-wr-tab]')).find(function(tab){
      return ['.wr__product-label','.wr__stage-label'].some(function(selector){
        var label=tab.querySelector(selector);
        if(!label)return false;
        var copy=label.cloneNode(true);
        copy.querySelectorAll('.wr__new').forEach(function(badge){badge.remove();});
        return stageKey(copy.textContent)===stageKey(key);
      });
    });
  }
  function syncButtons(){
    document.querySelectorAll('.fys [data-fys-routine-stage]').forEach(function(button){
      var target=document.getElementById(button.dataset.scrollTarget);
      button.hidden=!target||!tabFor(target,button.dataset.fysRoutineStage);
    });
  }
  document.addEventListener('click',function(event){
    var button=event.target.closest('.fys button[data-scroll-target]');
    if(!button)return;
    var target=document.getElementById(button.dataset.scrollTarget);
    if(!target)return;
    var routineTab;
    if(button.hasAttribute('data-fys-routine-stage')){
      routineTab=tabFor(target,button.dataset.fysRoutineStage);
      var status=button.parentElement.querySelector('.fys__routine-status');
      if(!routineTab||!target._wrEngine){
        if(status){status.textContent='The routine builder is not ready. Please try again shortly.';status.hidden=false;}
        return;
      }
      routineTab.click();
      if(status){status.textContent='';status.hidden=true;}
    }
    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
    if(routineTab){routineTab.focus({preventScroll:true});return;}
    if(!target.hasAttribute('tabindex')){
      target.setAttribute('tabindex','-1');
      target.addEventListener('blur',function(){target.removeAttribute('tabindex');},{once:true});
    }
    target.focus({preventScroll:true});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',syncButtons);else syncButtons();
  window.addEventListener('load',syncButtons);
  document.addEventListener('shopify:section:load',function(){window.requestAnimationFrame(syncButtons);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womens-90-day-kit-intro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  if(!(event.target instanceof Element))return;
  var button=event.target.closest('.wki button[data-scroll-target]');
  if(!button)return;
  var target=document.getElementById(button.dataset.scrollTarget);
  if(!target)return;
  var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
  if(!target.hasAttribute('tabindex')){
    target.setAttribute('tabindex','-1');
    target.addEventListener('blur',function(){target.removeAttribute('tabindex');},{once:true});
  }
  target.focus({preventScroll:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womens-patch-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  var questions=[
    {title:'Where are you in your life stage?',intro:'Choose the description that feels closest. It’s okay not to be sure.',options:[
      ['premenstrual','My cycle is regular','I’m in my cycling years.'],
      ['peri-m','I’m in perimenopause','I’m still having periods, but things are changing.'],
      ['menopause','I’m going through menopause','I identify with the menopause transition.'],
      ['post-m','I’m post-menopause','I know I’m in the stage after menopause.'],
      ['unsure','I’m not sure yet','Help me compare the stages.']
    ]},
    {title:'What would you most like to explore?',intro:'Pick the focus that matters most to you today.',options:[
      ['cycle','My monthly routine','The days around my period.'],
      ['mood','Mood and energy','The changing, still-cycling years.'],
      ['flushes','Flushes and disrupted nights','Support through the transition.'],
      ['body','My routine after menopause','The physical changes in this stage.'],
      ['compare','I’d like to compare first','I’m still working out what fits.']
    ]},
    {title:'What would help you most next?',intro:'Choose how you’d like to explore.',options:[
      ['patch','Show me a patch to explore','Start with the product for my stage.'],
      ['routine','Help me build a routine','See my stage patch with optional additions.'],
      ['compare','Let me compare the stages','I want to understand the differences first.']
    ]}
  ];
  var labels={'premenstrual':'Cycling Years','peri-m':'Perimenopause','menopause':'Menopause','post-m':'Post Menopause'};
  var focusLabels={cycle:'Your monthly routine',mood:'Mood and energy',flushes:'Flushes and disrupted nights',body:'Your routine after menopause',compare:'Comparing the options'};
  function resolve(answers){
    var key=answers[0],focus=answers[1],next=answers[2];
    if(!labels[key]){
      var pairs={cycle:['premenstrual','peri-m'],mood:['peri-m','menopause'],flushes:['menopause','post-m'],body:['menopause','post-m']};
      return {key:null,keys:pairs[focus]||Object.keys(labels),compare:true};
    }
    return {key:key,keys:[key],compare:focus==='compare'||next==='compare'};
  }
  function normalize(value){return String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');}
  function findTab(target,key){
    var aliases={'premenstrual':['premenstrual','cyclingyears'],'peri-m':['perim','perimenopause'],'menopause':['menopause'],'post-m':['postm','postmenopause','postmenopausal']};
    return Array.from(target.querySelectorAll('[data-wr-tab]')).find(function(tab){return ['.wr__product-label','.wr__stage-label'].some(function(selector){var el=tab.querySelector(selector);if(!el)return false;var copy=el.cloneNode(true);copy.querySelectorAll('.wr__new').forEach(function(b){b.remove();});return aliases[key].indexOf(normalize(copy.textContent))!==-1;});});
  }
  function init(root){
    if(root._wqCleanup)return;
    var dialog=root.querySelector('dialog');
    var launcher=root.querySelector('[data-wq-launch]');
    if(!dialog||typeof dialog.showModal!=='function'){launcher.hidden=true;return;}
    var controller=new AbortController(),options={signal:controller.signal},timer;
    var answers=[],step=0,returnFocus,previousOverflow,scrollLocked=false;
    var heading=root.querySelector('[data-wq-title]'),intro=root.querySelector('[data-wq-intro]'),choices=root.querySelector('[data-wq-options]'),result=root.querySelector('[data-wq-result]'),next=root.querySelector('[data-wq-next]'),back=root.querySelector('[data-wq-back]'),status=root.querySelector('[data-wq-status]');
    var sessionKey='tpr-womens-guide-shown-v1';
    function markShown(){try{sessionStorage.setItem(sessionKey,'1');}catch(e){}}
    function shown(){try{return sessionStorage.getItem(sessionKey)==='1';}catch(e){return true;}}
    function reset(){answers=[];step=0;status.textContent='';result.replaceChildren();render();}
    function lock(){if(scrollLocked)return;previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';scrollLocked=true;}
    function unlock(){if(!scrollLocked)return;document.body.style.overflow=previousOverflow;scrollLocked=false;}
    function open(trigger){
      if(dialog.open)return;
      if(document.querySelector('dialog[open]'))return;
      reset();returnFocus=trigger||document.activeElement;dialog.showModal();lock();markShown();heading.focus();
    }
    function close(){if(dialog.open)dialog.close();}
    function render(){
      var question=questions[step];
      root.querySelector('.wq__body').classList.remove('wq__body--result');intro.hidden=false;back.textContent='← Back';
      choices.hidden=false;result.hidden=true;back.hidden=step===0;next.hidden=false;next.disabled=!answers[step];next.textContent=step===2?'See my next step →':'Next →';
      heading.textContent=question.title;intro.textContent=question.intro;root.querySelector('[data-wq-step]').textContent='Question '+(step+1)+' of 3';root.querySelector('[data-wq-progress]').style.width=((step+1)/3*100)+'%';
      choices.replaceChildren();var legend=document.createElement('legend');legend.className='wq__sr';legend.textContent='Choose one answer';choices.append(legend);
      question.options.forEach(function(option){var label=document.createElement('label');label.className='wq__option';var radio=document.createElement('input');radio.type='radio';radio.name='wq-'+root.dataset.wqSection+'-'+step;radio.value=option[0];radio.checked=answers[step]===option[0];var copy=document.createElement('span'),title=document.createElement('strong'),detail=document.createElement('small');title.textContent=option[1];detail.textContent=option[2];copy.append(title,detail);label.append(radio,copy);choices.append(label);});
    }
    function compareOnPage(){
      var destination=document.querySelector('.fys');
      if(destination){var focus=destination.querySelector('h2');if(focus){if(!focus.hasAttribute('tabindex'))focus.setAttribute('tabindex','-1');returnFocus=focus;}close();destination.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});if(focus)focus.focus({preventScroll:true});}
      else{status.textContent='The stage comparison is not available on this page. Please choose another next step.';}
    }
    function openRoutine(key){
      var target=document.getElementById(root.dataset.wqRoutine),tab=target&&findTab(target,key);
      if(!target||!tab){status.textContent='The routine builder is not available here yet. Please choose the patch option instead.';return false;}
      if(!target._wrEngine){status.textContent='The routine builder is still loading. Please try again shortly.';return false;}
      tab.click();returnFocus=tab;close();
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      tab.focus({preventScroll:true});return true;
    }
    function completeQuiz(){
      var key=answers[0];
      if(answers[2]==='compare'){compareOnPage();return;}
      if(answers[2]==='routine'&&labels[key]){openRoutine(key);return;}
      showResult();
    }
    function showResult(){
      var match=resolve(answers);choices.hidden=true;result.hidden=false;back.hidden=false;back.textContent='← Edit answers';next.hidden=true;
      root.querySelector('.wq__body').classList.add('wq__body--result');
      heading.textContent=match.key?'Your patch to explore':'Find your starting point';
      intro.hidden=!!match.key;intro.textContent=match.key?'':'Take a look at the four stages to find what feels closest.';
      result.replaceChildren();
      if(match.key){var template=root.querySelector('[data-wq-product="'+match.key+'"]');if(template)result.append(template.content.cloneNode(true));}
      else{var compare=document.createElement('button');compare.type='button';compare.className='wq__primary wq__shop';compare.textContent='Explore the four stages →';compare.addEventListener('click',compareOnPage,options);result.append(compare);}
      if(match.key){
        var target=document.getElementById(root.dataset.wqRoutine),tab=target&&findTab(target,match.key);
        if(target&&tab){var routine=document.createElement('button');routine.type='button';routine.className='wq__primary wq__routine';routine.textContent='Build a routine? →';routine.addEventListener('click',function(){openRoutine(match.key);},options);result.append(routine);}
      }
      dialog.scrollTop=0;heading.focus();
    }
    launcher.addEventListener('click',function(){open(launcher);},options);
    root.querySelector('[data-wq-close]').addEventListener('click',close,options);
    choices.addEventListener('change',function(event){if(event.target.type!=='radio')return;answers[step]=event.target.value;answers.splice(step+1);next.disabled=false;},options);
    next.addEventListener('click',function(){if(!answers[step])return;status.textContent='';if(step===2){completeQuiz();return;}step++;render();dialog.scrollTop=0;heading.focus();},options);
    back.addEventListener('click',function(){status.textContent='';if(!result.hidden){render();}else{step=Math.max(0,step-1);render();}heading.focus();},options);
    dialog.addEventListener('close',function(){unlock();reset();if(returnFocus&&returnFocus.isConnected)returnFocus.focus({preventScroll:true});},options);
    dialog.addEventListener('click',function(event){if(event.target!==dialog)return;var r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();},options);
    document.addEventListener('click',function(event){var button=event.target.closest('[data-open-womens-quiz]');if(!button)return;var id=button.dataset.openWomensQuiz;if(id&&id!==root.dataset.wqSection)return;if(!id&&document.querySelector('[data-wq-section]')!==root)return;event.preventDefault();open(button);},options);
    if(root.dataset.wqAuto==='true'&&!(window.Shopify&&window.Shopify.designMode)&&!shown()){
      timer=window.setTimeout(function(){if(document.hidden||shown()||document.querySelector('dialog[open]'))return;var active=document.activeElement;if(active&&active.matches('input,textarea,select,[contenteditable="true"]'))return;open(launcher);},Math.max(5,Number(root.dataset.wqDelay)||10)*1000);
    }
    root._wqCleanup=function(){window.clearTimeout(timer);close();unlock();controller.abort();delete root._wqCleanup;};
  }
  function initAll(){document.querySelectorAll('[data-wq-section]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
  document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-wq-section]').forEach(function(root){if(root._wqCleanup)root._wqCleanup();});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womens-routine-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var root=document.querySelector('[data-wr-section]');
    if(!root)return;
    var engines=document.querySelectorAll('.byob-page');
    var message=root.querySelector('[data-wr-message]');
    if(engines.length!==1||typeof window.byobToggle!=='function'||typeof window.byobMode!=='function'){
      message.textContent='The routine builder is loading. If it does not appear, open Build your own routine from the menu.';
      return;
    }
    var engine=engines[0];
    if(root._wrEngine===engine)return;
    if(engine._wrCleanup)engine._wrCleanup();
    root._wrEngine=engine;
    var controller=new AbortController();
    var listenerOptions={signal:controller.signal};
    var data=JSON.parse(root.querySelector('[data-wr-data]').textContent);
    if(!data.stages.length)return;
    engine.classList.add('wr-engine');
    engine.style.setProperty('--wr-engine-accent',data.accent);
    engine.style.setProperty('--wr-bottom',getComputedStyle(root).getPropertyValue('--wr-pad'));
    engine.style.setProperty('--wr-bottom-mobile',getComputedStyle(root).getPropertyValue('--wr-mobile'));
    engine.querySelectorAll('.wr-benefits').forEach(function(strip){strip.remove();});
    var benefits=root.querySelector('[data-wr-benefits]');
    if(benefits)engine.append(benefits.content.cloneNode(true));
    engine.querySelectorAll('.wr-more').forEach(function(link){link.remove();});
    var more=root.querySelector('[data-wr-more]');
    var picker=engine.querySelector('.byob-picker');
    if(more&&picker)picker.append(more.content.cloneNode(true));
    var formatter=new Intl.NumberFormat(data.locale,{style:'currency',currency:data.currency,currencyDisplay:'narrowSymbol'});
    var decimals=formatter.resolvedOptions().maximumFractionDigits;
    var tokenName=decimals===0?'amount_no_decimals':formatter.formatToParts(1.11).some(function(p){return p.type==='decimal'&&p.value===',';})?'amount_with_comma_separator':'amount';
    var token='{'+ '{'+tokenName+'}'+ '}';
    var inserted=false;
    window.TPR_MONEY_FORMAT=formatter.formatToParts(1.11).map(function(p){
      if(['integer','group','decimal','fraction'].indexOf(p.type)!==-1){if(inserted)return '';inserted=true;return token;}
      return p.value;
    }).join('');
    function money(cents){return formatter.format(cents/100);}
    var cards=Array.from(engine.querySelectorAll('.byob-patch'));
    var catalog=new Map();
    data.stages.forEach(function(stage){stage.products.forEach(function(p){catalog.set(p.variant,p);});});
    var stageIndex=-1;
    var selections={};
    var cta=engine.querySelector('#byob-cta');
    var frequency=engine.querySelector('#byob-frequency');
    if(!engine._wrOriginalPlans)engine._wrOriginalPlans=Array.from(frequency.options).map(function(o){return {id:o.value,name:o.textContent};});
    var originalPlans=engine._wrOriginalPlans;
    var busy=false;
    var observer;
    function cardFor(id){return cards.find(function(c){return c.dataset.variantId===id;});}
    function selectedCards(){return cards.filter(function(c){return c.classList.contains('is-selected');});}
    function isSubscription(){return !!engine.querySelector('.byob-tab.is-active[data-mode="subscribe"]');}
    function accessible(){
      cards.forEach(function(card){
        var p=catalog.get(card.dataset.variantId);
        var disabled=!p||!p.single||!p.available;
        card.setAttribute('role','group');card.setAttribute('aria-disabled',String(disabled));
        card.setAttribute('aria-label',card.dataset.title);
        var label=card.querySelector('.wr__select');
        if(label){label.disabled=disabled;label.setAttribute('aria-pressed',String(card.classList.contains('is-selected')));label.setAttribute('aria-label',(card.classList.contains('is-selected')?'Remove ':'Select ')+card.dataset.title);label.textContent=disabled?'Unavailable':card.classList.contains('is-selected')?'✓ Selected':'+ Add to selection';}
      });
    }
    function guard(){
      if(busy)return;
      if(observer)observer.disconnect();
      accessible();
      var chosen=selectedCards();
      var invalid=chosen.some(function(c){var p=catalog.get(c.dataset.variantId);return !p||!p.available||!p.single;});
      var common=originalPlans.filter(function(plan){return chosen.every(function(c){var p=catalog.get(c.dataset.variantId);return p&&p.plans.some(function(a){return a.id===plan.id;});});});
      var previous=frequency.value;
      var planSignature=common.map(function(p){return p.id;}).join(',');
      if(frequency.dataset.wrPlans!==planSignature){
        frequency.replaceChildren();
        common.forEach(function(plan){var o=document.createElement('option');o.value=plan.id;o.textContent=plan.name;frequency.append(o);});
        if(common.some(function(p){return p.id===previous;}))frequency.value=previous;
        frequency.dataset.wrPlans=planSignature;
      }
      var problem='';
      if(invalid)problem='Remove unavailable patches to continue.';
      if(isSubscription()&&chosen.length){
        if(!common.length)problem='These patches do not share a subscription option. Choose Buy once or change your patches.';
        else {
          var expected=0,actual=0;
          chosen.forEach(function(c){var p=catalog.get(c.dataset.variantId),q=Number(c.querySelector('.byob-qty-val').textContent)||1;expected+=p.price*q;actual+=p.plans.find(function(a){return a.id===frequency.value;}).price*q;});
          if(Math.abs(Math.round(expected*.85)-actual)>1)problem='The subscription price needs checking. Please use Buy once for now.';
        }
      }
      if(problem){cta.disabled=true;message.textContent=problem;}
      else if(!root.dataset.wrConfigProblem){message.textContent='';}
      if(observer)observer.observe(engine,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
    }
    function showStage(index){
      busy=true;if(observer)observer.disconnect();
      var old=data.stages[stageIndex];
      if(old)selections[old.id]=selectedCards().map(function(c){return {id:c.dataset.variantId,qty:Number(c.querySelector('.byob-qty-val').textContent)||1};});
      selectedCards().forEach(function(c){window.byobRemove(c.dataset.variantId);});
      stageIndex=index;
      var stage=data.stages[index];
      root.querySelectorAll('[data-wr-tab]').forEach(function(tab,i){tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
      root.querySelector('.wr__panel').setAttribute('aria-labelledby','wr-tab-'+stage.id);
      root.querySelector('[data-wr-title]').textContent=stage.heading;
      root.querySelector('[data-wr-copy]').textContent=stage.copy;
      var unique=stage.products.filter(function(p,i,arr){return arr.findIndex(function(other){return other.variant===p.variant;})===i;});
      var visible=unique.filter(function(p){return p.single&&cardFor(p.variant);});
      var ids=visible.map(function(p){return p.variant;});
      cards.forEach(function(c){c.classList.toggle('is-hidden',ids.indexOf(c.dataset.variantId)===-1);c.querySelectorAll('.wr__new').forEach(function(b){b.remove();});});
      visible.forEach(function(p,i){
        var c=cardFor(p.variant);c.style.order=String(i);c.dataset.price=String(p.price);
        if(stage.isNew&&p.core){var badge=document.createElement('span');badge.className='wr__new';badge.textContent=data.newText;c.querySelector('.byob-patch__name').append(badge);}
      });
      var saved=selections[stage.id];
      if(!saved){var main=visible.find(function(p){return p.core&&p.available;});saved=main?[{id:main.variant,qty:1}]:[];}
      saved.forEach(function(item){var p=visible.find(function(p){return p.variant===item.id;});if(!p||!p.available)return;var c=cardFor(item.id);window.byobToggle(c);for(var q=1;q<item.qty;q++)window.byobQtyChange(c.querySelectorAll('.byob-qty-btn')[1],1);});
      var missing=unique.length-visible.length;
      var noCore=!unique.some(function(p){return p.core;});
      root.dataset.wrConfigProblem=missing||noCore||!visible.length?'true':'';
      message.textContent=!visible.length?'This stage’s routine is coming soon.':missing||noCore?'Some patches are not available in this stage yet. Explore the available choices below.':'';
      busy=false;guard();
    }
    cards.forEach(function(card){
      var p=catalog.get(card.dataset.variantId);
      if(p)card.dataset.price=String(p.price);
      if(!card.querySelector('.wr__select')){
        var price=document.createElement('span');price.className='wr__price';price.textContent=money(p?p.price:Number(card.dataset.price))+' | 30 patches';
        var select=document.createElement('button');select.type='button';select.className='wr__select';select.textContent='+ Add to selection';
        card.querySelector('.byob-patch__name').after(price);card.append(select);
      }
    });
    var once=engine.querySelector('[data-mode="onetime"]');window.byobMode(once);
    root.querySelectorAll('[data-wr-tab]').forEach(function(tab,i){
      tab.addEventListener('click',function(){showStage(i);},listenerOptions);
      tab.addEventListener('keydown',function(event){var next;if(event.key==='ArrowRight')next=(i+1)%data.stages.length;if(event.key==='ArrowLeft')next=(i+data.stages.length-1)%data.stages.length;if(event.key==='Home')next=0;if(event.key==='End')next=data.stages.length-1;if(next!==undefined){event.preventDefault();showStage(next);root.querySelectorAll('[data-wr-tab]')[next].focus();}},listenerOptions);
    });
    engine.addEventListener('click',function(event){
      var card=event.target.closest('.byob-patch');
      if(card&&card.getAttribute('aria-disabled')==='true'){event.preventDefault();event.stopImmediatePropagation();return;}
      if(event.target.closest('#byob-cta')){guard();if(cta.disabled){event.preventDefault();event.stopImmediatePropagation();}}
    },{capture:true,signal:controller.signal});
    frequency.addEventListener('change',function(){window.byobMode(engine.querySelector('.byob-tab.is-active'));guard();},listenerOptions);
    observer=new MutationObserver(guard);
    engine._wrCleanup=function(){controller.abort();observer.disconnect();root._wrEngine=null;};
    showStage(0);
    document.addEventListener('shopify:block:select',function(event){var index=data.stages.findIndex(function(s){return s.id===event.detail.blockId;});if(index!==-1)showStage(index);},listenerOptions);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.addEventListener('load',init);
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womens-starter-kits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){
  if(!(event.target instanceof Element))return;
  var form=event.target.closest('.wsk .wsk__form');
  if(!form)return;
  if(event.target.matches('[data-wsk-variant]')){
    var template=Array.from(form.querySelectorAll('template[data-wsk-variant-panel]')).find(function(item){return item.dataset.wskVariantPanel===event.target.value;});
    if(template)form.querySelector('[data-wsk-purchase-panel]').replaceChildren(template.content.cloneNode(true));
  }
  if(event.target.matches('[data-wsk-plan]')){
    var option=event.target.selectedOptions[0];
    if(!option)return;
    form.querySelector('.wsk__price[data-wsk-price]').textContent=option.dataset.wskPrice||'';
    var buttonPrice=form.querySelector('[data-wsk-button-price]');
    if(buttonPrice)buttonPrice.textContent=' — '+(option.dataset.wskPrice||'');
    var saving=form.querySelector('.wsk__saving[data-wsk-saving]');
    saving.textContent=option.dataset.wskSaving||'';
    saving.hidden=!saving.textContent.trim();
  }
});

  } catch(e) { console.error(e); }
})();
})();
